import React from 'react';
import { Col, Modal, Row, Button, Glyphicon } from 'react-bootstrap';
import API from 'fw/system/API';
import { TextBox, Grid } from 'fw/forms';
import * as APIModules from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';

class CompanyAssociationPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            loading: false,
            visible: props.visible,
            list: [],
            companyId: null,
            searchText: "",
            showMoreRecords: false,
            rowCount: props.rowCount,
            sorting: {
                sortField: "Name",
                sortDirection: "ASC"
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible
        });
        if (nextProps.visible) {
            this.search()
        }
    }

    urls() {
        return {
            searchCompany: APIModules.Security.url('/userSetup/searchCompany'),
            saveCompanyAssociation: APIModules.Security.url('/userSetup/saveCompanyAssociation')
        }
    }

    close = () => {
        this.setState({
            searchText: "",
            visible: false,
            companyId: null,
        }, function () {
            this.props.onClose();
        });
    }

    save = () => {
        let me = this;

        let rq = {
            userId: me.props.userId,
            companyId: me.state.companyId
        }

        new API().post(this.urls().saveCompanyAssociation, rq,
            {
                success: (r) => {
                    this.props.onSave(r.data);
                    Notifications.success(r.message);
                    this.close();
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
    }

    search = () => {
        let me = this;

        let rq = {
            userId: me.props.userId,
            searchText: me.state.searchText,
            sortField: me.state.sorting.sortField,
            sortDirection: me.state.sorting.sortDirection,
            rowCount: me.state.rowCount
        }

        new API().post(this.urls().searchCompany, rq,
            {
                success: (r) => {
                    me.setState({ list: r.data.items })
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
    }

    reset = () => {
        this.setState({
            searchText: "",
            sortField: "Name",
            sortDirection: "ASC",
            companyId: null,
            rowCount: this.props.rowCount
        }, this.search);
    }

    handleLoadMoreResults = () => {
        this.setState({
            rowCount: this.state.rowCount + this.props.rowCount
        }, function () {
            this.search()
        });
    }

    handleSort = (sortField, sortDirection) => {
        this.setState({
            sorting: {
                sortField: sortField,
                sortDirection: sortDirection
            }
        }, function () { this.search(); });
    }

    setSearchText = (v) => {
        var me = this;
        me.setState({ searchText: v });
    }

    handleSelect = (id) => {
        this.setState({ companyId: id });
    }

    render() {
        if (this.state.loading)
            return null;

        let me = this;
        return (
            <Modal
                show={this.state.visible}
                onHide={this.close}>
                <Modal.Header>
                    <h3>Company Association – <small>Associate a Company and Role to a User</small></h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        <Row>
                            <Col md={6}>
                                <div>
                                    <TextBox placeholder="Search company..." value={me.state.searchText} onChange={(v) => me.setSearchText(v)} autoFocus />
                                    <Glyphicon className="pull-right" glyph="search" style={{ color: "#bbb", marginTop: "-27px", marginRight: "10px" }} />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="pull-right">
                                    <Button id="btnSearch" onClick={me.search} bsStyle="primary" style={{ marginRight: 5, width: 70 }}>Search</Button>
                                    <Button id="btnReset" onClick={me.reset} bsStyle="default" style={{ marginRight: 0, width: 65 }}>Reset</Button>
                                </div>
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col md={12}>
                                <Grid
                                    height={300}
                                    columns={[{ key: 'companyName', name: 'Company Name', sortable: true }]}
                                    rowKey={"companyId"}
                                    sortField={this.state.sorting.sortField}
                                    sortDirection={this.state.sorting.sortDirection}
                                    items={this.state.list}
                                    onChange={this.handleSelect}
                                    onSort={this.handleSort}
                                />
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        {this.state.showMoreRecords &&
                            <Row>
                                <Col md={12}>
                                    <Button id="btnViewMoreResults" className="pull-right" onClick={this.handleLoadMoreResults}>
                                        <Glyphicon glyph="glyphicon glyphicon-repeat" style={{ marginRight: 10 }} />Show more results
                                </Button>
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnOnClose" onClick={this.close}>Close</Button>
                    <Button id="btnOnSave" bsStyle="primary" disabled={this.state.companyId === null} onClick={this.save}>Save Changes</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

CompanyAssociationPopUp.defaultProps = {
    rowCount: 50
};

export default CompanyAssociationPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/userSetup/userInfo/CompanyAssociationPopUp.js